import { loadable } from '@change-corgi/core-react/loadable';

import type { AppRoute } from '#src/shared/routes';

import { Loading } from '#src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'admin-vanity-delete',
		path: '/admin/custom_urls/delete',
		component: loadable(async () => import(/* webpackChunkName: "pages/admin-vanity-delete" */ './index'), {
			exportName: 'AdminVanityDelete',
			fallback: Loading,
		}),
		restrictedAccess: {
			authOnly: true,
			role: ['staff', 'support'],
		},
		frame: true,
		ssr: {
			enabled: false,
			seo: false,
		},
	},
];
